import { useState } from 'react';
import { SEO_FAQS } from './SEOHead';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section
      id="faq"
      className="bg-[#050505] py-20 sm:py-28 border-t border-white/[0.08] w-full"
    >
      <div className="w-full px-5 sm:px-10 lg:px-16 xl:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.6fr] gap-10 lg:gap-16">
          <div>
            <p className="text-[11px] uppercase tracking-[0.14em] text-[#767d88] mb-2">
              Questions &amp; Answers
            </p>
            <h2 className="text-white font-normal tracking-[-0.03em] leading-[1.05] text-[clamp(1.85rem,3.4vw,3.25rem)]">
              Frequently asked questions.
            </h2>
            <p className="text-[#767d88] text-sm sm:text-[15px] mt-3 max-w-sm">
              How our 100% AI-Native and Hybrid VFX engines work for brands, agencies, and
              film productions.
            </p>
          </div>

          <div className="divide-y divide-white/[0.08] border-y border-white/[0.08]">
            {SEO_FAQS.map((item, idx) => {
              const isOpen = openIndex === idx;
              return (
                <div key={item.question} className="py-5">
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? -1 : idx)}
                    className="w-full flex items-center justify-between gap-4 text-left cursor-pointer"
                    aria-expanded={isOpen}
                  >
                    <span className="text-[17px] font-medium tracking-[-0.02em] text-white">
                      {item.question}
                    </span>
                    <span className="text-white/50 text-xl font-light shrink-0">
                      {isOpen ? '−' : '+'}
                    </span>
                  </button>
                  {isOpen && (
                    <p className="text-[14px] text-[#767d88] leading-relaxed mt-3 pr-8">
                      {item.answer}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
